
// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const ReportLayoutColumnState = t.struct({
    aggFunc: t.maybe(t.String),
    colId: t.String,
    hide: t.Bool,
    pinned: t.maybe(t.String),
    pivotIndex: t.maybe(t.Number),
    rowGroupIndex: t.maybe(t.Number),
    width: t.Number
}, {
    name: 'ReportLayoutColumnState'
});

export const getDefaultState = () => new ReportLayoutColumnState({
    aggFunc: '',
    colId: '',
    hide: false,
    pinned: '',
    pivotIndex: null,
    rowGroupIndex: null,
    width: 0
});

export default ReportLayoutColumnState;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/report-layout-column-state.js